

// See http://johnborg.es/2020/03/stenciljs-environment-variables.html

export const resources = {
  dev: {
    apiUri: `https://localhost:6001/graphql`,
    assetsUri: `https://localhost:7001`,
    insightUri: `https://localhost:4300`,
    treeviewerUri: `https://localhost:3333`,
    apiTimeout: 3000,
  },
  test: {
    apiUri: `https://api.test.unfootprint.com/graphql`,
    assetsUri: `https://assets.test.unfootprint.com`,
    insightUri: `https://insight.test.unfootprint.com`,
    treeviewerUri: `https://treeviewer.test.unfootprint.com`,
    apiTimeout: 6000,
  },
  acc: {
    apiUri: `https://api.acc.unfootprint.com/graphql`,
    assetsUri: `https://assets.acc.unfootprint.com`,
    insightUri: `https://insight.acc.unfootprint.com`,
    treeviewerUri: `https://treeviewer.acc.unfootprint.com`,
    apiTimeout: 6000,
  },
  prod: {
    apiUri: `https://api.unfootprint.com/graphql`,
    assetsUri: `https://assets.unfootprint.com`,
    insightUri: `https://insight.unfootprint.com`,
    treeviewerUri: `https://treeviewer.unfootprint.com`,
    apiTimeout: 6000,
  }
};